import { render, staticRenderFns } from "./ArchivoSolicitudCard.vue?vue&type=template&id=5776ca06&scoped=true"
import script from "./ArchivoSolicitudCard.vue?vue&type=script&lang=ts"
export * from "./ArchivoSolicitudCard.vue?vue&type=script&lang=ts"
import style0 from "./ArchivoSolicitudCard.vue?vue&type=style&index=0&id=5776ca06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5776ca06",
  null
  
)

export default component.exports